// Set up your application entry point here...
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import configureStore, { history } from "./store/configureStore";
import Root from "./Root";
import "./styles/styles.scss";
import theme from "./theme";
require("./favicon.ico");
const store = configureStore();

render(
    <AppContainer>
        <Root store={store} history={history} theme={theme} />
    </AppContainer>,
    document.getElementById("app")
);

if (module.hot) {
    module.hot.accept("./Root", () => {
        const NewRoot = require("./Root").default;
        render(
            <AppContainer>
                <NewRoot store={store} history={history} theme={theme} />
            </AppContainer>,
            document.getElementById("app")
        );
    });
}
